import React from "react";
import _ from "lodash";
import submit from "submit-form";

import GroupCheckbox from "../inputs/group-checkbox";
import Select from "../inputs/select";
import RangeInput from "../inputs/range-input";

class ProgramFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tabFilter: false };

    this.toggleTabFilter = this.toggleTabFilter.bind(this);
  }

  toggleTabFilter() {
    this.setState({
      tabFilter: !this.state.tabFilter,
    });
  }

  render() {
    const { props } = this;

    const { query, coachingPortal, locals } = props;
    const { coaches, activeUser } = locals;
    const { athletes } = activeUser;
    const { tabFilter } = this.state;
    const squatMinMax = getMinAndMaxFrequencies("squat", query);
    const benchMinMax = getMinAndMaxFrequencies("bench", query);
    const deadliftMinMax = getMinAndMaxFrequencies("deadlift", query);
    const referAsClients = activeUser.referAsClients;
    return (
      <div className={`Library-Filter ${tabFilter ? "open-filter" : ""}`}>
        <div className="mobile-header">
          Filter Programs
          <label htmlFor="mobile-filter-toggle" className="close">
            <img src="/img/svg/icon_dismiss.svg" width="20" height="20" />
          </label>
        </div>

        <div className="filter-titles">
          <h2>Filters</h2>
          <div onClick={this.toggleTabFilter}>
            {tabFilter ? "Close" : "Open"} Filters{"  "}
            <img
              src="/img/icons/chevron-down.svg"
              className="chevron-metrics"
            ></img>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-element element-20">
            {!coachingPortal && (
              <div className="group">
                <div className="label">Coach</div>
                <Select
                  name="filters[cycleAuthorId]"
                  className="select-input"
                  value={_.get(query, "filters.cycleAuthorId", "any")}
                >
                  <option value="any">Coach Name</option>
                  {_.map(coaches, (coach) => (
                    <option key={coach._id} value={coach._id}>
                      {coach.name}
                    </option>
                  ))}
                </Select>
              </div>
            )}

            {coachingPortal && (
              <div className="group">
                <div className="label">
                  {referAsClients ? "Client" : "Athlete"}
                </div>
                <Select
                  name="filters[owner]"
                  className="select-input"
                  value={_.get(query, "filters[owner]", "any")}
                >
                  <option value="any">
                    {referAsClients ? "Client" : "Athlete"} Name
                  </option>
                  {_.map(athletes, (athlete) => (
                    <option key={athlete._id} value={athlete._id}>
                      {athlete.name}
                    </option>
                  ))}
                </Select>
              </div>
            )}
          </div>
          <div className="filter-element element-20">
            <GroupCheckbox
              name="filters[difficulty]"
              title="Difficulty"
              checkboxes={[
                { html: "Novice", value: "Novice" },
                { html: "Intermediate", value: "Intermediate" },
                { html: "Advanced", value: "Advanced" },
              ]}
            />
          </div>
          <div className="filter-element element-40">
            <div className="group">
              <div className="label">Frequency of lifts</div>
              <div className="Frequency-Selector">
                <input
                  type="radio"
                  name="frequency-selector"
                  value="squat"
                  id="frequency-squat"
                />
                <input
                  type="radio"
                  name="frequency-selector"
                  value="bench"
                  id="frequency-bench"
                />
                <input
                  type="radio"
                  name="frequency-selector"
                  value="deadlift"
                  id="frequency-deadlift"
                />
                <input
                  type="radio"
                  name="frequency-selector"
                  value="reset"
                  id="frequency-reset"
                />

                <div className="selector-groups">
                  <div className="selector-group squat">
                    <RangeInput
                      nameRangeInput="Squat"
                      minName=""
                      maxName=""
                      min={0}
                      max={7}
                      step={1}
                      defaultValue={squatMinMax}
                      onChange={(e) =>
                        handleLiftFrequencyFilter(e, "squat", query)
                      }
                    />
                  </div>

                  <div className="selector-group bench">
                    <RangeInput
                      nameRangeInput="Bench"
                      minName=""
                      maxName=""
                      min={0}
                      max={7}
                      step={1}
                      defaultValue={benchMinMax}
                      onChange={(e) =>
                        handleLiftFrequencyFilter(e, "bench", query)
                      }
                    />
                  </div>

                  <div className="selector-group deadlift">
                    <RangeInput
                      nameRangeInput="Deadlift"
                      minName=""
                      maxName=""
                      min={0}
                      max={7}
                      step={1}
                      defaultValue={deadliftMinMax}
                      onChange={(e) =>
                        handleLiftFrequencyFilter(e, "deadlift", query)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="filter-element element-20">
            <GroupCheckbox
              name="filters[liftPriority]"
              title="Lift Priority"
              checkboxes={[
                { html: "Bench", value: "Bench" },
                { html: "Deadlift", value: "Deadlift" },
                { html: "Squat", value: "Squat" },
              ]}
            />
          </div>
        </div>
        <div className="filter-group ">
          <div className="filter-element element-20">
            <GroupCheckbox
              name="filters[volume]"
              title="Volume"
              checkboxes={[
                { html: "High", value: "High" },
                { html: "Medium", value: "Medium" },
                { html: "Low", value: "Low" },
              ]}
            />
          </div>
          <div className="filter-element element-20">
            {" "}
            <GroupCheckbox
              name="filters[intensity]"
              title="Intensity"
              checkboxes={[
                { html: "High", value: "High" },
                { html: "Medium", value: "Medium" },
                { html: "Low", value: "Low" },
              ]}
            />
          </div>
          <div className="filter-element element-40">
            {" "}
            <GroupCheckbox
              name="filters[sessionsPerWeek]"
              title="Sessions per week"
              checkboxes={_.map(_.range(1, 8), (value) => ({
                html: `${value} ${value > 1 ? "sessions" : "session"}`,
                value,
              }))}
            />
          </div>
          <div className="filter-element element-20">
            {" "}
            <GroupCheckbox
              name="filters[weeksToCompetition]"
              title="Next competition"
              checkboxes={_.times(4, (value) => ({
                html: `${["4", "8", "12", "12+"][value]} weeks out`,
                value: ["four", "eight", "twelve", "more"][value],
              }))}
            />
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-element element-20">
            <div className="group">
              <div className="label">Equipped Lifting</div>
              <Select
                name="filters[isEquippedLifting]"
                className="select-input"
                value={_.get(query, "filters.isEquippedLifting", "any")}
              >
                <option value="any">Select One</option>
                <option value="equipped">Yes</option>
                <option value="notEquipped">No</option>
              </Select>
            </div>
          </div>
          <div className="filter-element element-20">
            <div className="group">
              <div className="label">Equipment Type</div>
              <Select
                name="filters[equipmentRequired]"
                className="select-input"
                value={_.get(query, "filters.equipmentRequired", "any")}
              >
                <option value="any">Choose Equipment</option>
                <option value="Barbell Only">Barbell Only</option>
                <option value="Barbell / Dumbbells">Barbell / Dumbbells</option>
                <option value="Barbell / Dumbbells / Cables">
                  Barbell / Dumbbells / Cables
                </option>
                <option value="Full Gym Capability">Full Gym Capability</option>
              </Select>
            </div>
          </div>
        </div>

        <div className="buttons">
          <a href="/actions/refresh/?filters=">Clear Filters</a>
        </div>
      </div>
    );
  }
}

function handleLiftFrequencyFilter(e, liftName, query) {
  const valuesArray = _.range(Math.round(e[0]), Math.round(e[1]) + 1);

  return submit(`/actions/refresh?`, {
    method: "GET",
    body: { [`filters[${liftName}Frequency]`]: valuesArray.join(",") },
  });
}

function getMinAndMaxFrequencies(liftName, query) {
  const frequencies = _.get(query, `filters.${liftName}Frequency`, [0, 7]);
  const min = frequencies[0];
  const max = _.last(frequencies);
  return [min, max];
}

export default ProgramFilters;
